import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, change } from 'redux-form';
import { Button } from 'semantic-ui-react';
import { InputField, CheckboxField } from 'Common/SemanticWrapper';
import _ from 'lodash';

import {
  RecipeFieldEnum as Fields,
  RecipeVerified as Verified,
} from 'Common/FieldEnum';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';

export const labels = {
  [Fields.NoAllergens]: 'No Allergens',
  [Fields.AllergensNotAvailable]: 'Allergens Not Available',
};

export default class Allergens extends Component {
  static propTypes = {
    formName: PropTypes.string.isRequired,
    formValues: PropTypes.object.isRequired,
    isReadOnly: PropTypes.bool,
  };

  static defaultProps = {
    isReadOnly: false,
  };

  unverified = (key) => {
    const { dispatch, formName } = this.props;
    dispatch(change(formName, `${Fields.Verified}.${key}`, false));
  };

  verified = (key) => {
    const { dispatch, formName } = this.props;
    dispatch(change(formName, `${Fields.Verified}.${key}`, true));
  };

  handleAllergenRowClick = (allergen, recipeAllergens) => {
    const { dispatch, formValues, formName } = this.props;
    let newAllergens = [...formValues[Fields.Allergens]];
    const newAllergenIds = newAllergens.map((a) => a.Id);

    const recipeAllergen = recipeAllergens.find(
      (recipeAllergen) => recipeAllergen.Id === allergen.Id
    );

    if (recipeAllergen && recipeAllergen.FromIngredient) {
      dispatch(
        setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.ALLERGEN_FROM_INGREDIENT
        )
      );

      return;
    }

    if (!newAllergenIds.includes(allergen.Id)) {
      newAllergens.push({
        Id: allergen.Id,
        Description: allergen.Description,
        FromIngredient: false,
      });
    } else {
      newAllergens = newAllergens.filter((a) => a.Id !== allergen.Id);
    }
    dispatch(change(formName, Fields.AllergensNotAvailable, false));
    dispatch(change(formName, Fields.NoAllergens, false));
    dispatch(change(formName, Fields.Allergens, newAllergens));
    this.unverified(Verified.Allergens);
  };

  handleNoAllergensClick = () => {
    const { dispatch, formValues, formName } = this.props;

    if (this.hasAllergensFromIngredients()) {
      dispatch(
        setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.ALLERGENS_FROM_INGREDIENTS
        )
      );
      return;
    }

    dispatch(
      change(formName, Fields.NoAllergens, !formValues[Fields.NoAllergens])
    );
    dispatch(change(formName, Fields.AllergensNotAvailable, false));
    dispatch(change(formName, Fields.Allergens, []));
    this.unverified(Verified.Allergens);
  };

  handleAllergensNotAvailableClick = () => {
    const { dispatch, formValues, formName } = this.props;

    if (this.hasAllergensFromIngredients()) {
      dispatch(
        setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.ALLERGENS_FROM_INGREDIENTS
        )
      );
      return;
    }

    dispatch(
      change(
        formName,
        Fields.AllergensNotAvailable,
        !formValues[Fields.AllergensNotAvailable]
      )
    );
    dispatch(change(formName, Fields.NoAllergens, false));
    dispatch(change(formName, Fields.Allergens, []));
    this.unverified(Verified.Allergens);
  };

  handleAddCustomAllergenClick = (e) => {
    const { dispatch, formValues, formName } = this.props;
    const newAllergens = [...formValues[Fields.AllAllergens]];

    if (
      _.find(newAllergens, (allergen) => allergen.Description.trim() === '')
    ) {
      return;
    }

    newAllergens.push({
      Id: parseInt(_.uniqueId('100000'), 10),
      Description: '',
      IsCustom: true,
      FromIngredient: false,
      IsNew: true,
    });

    dispatch(change(formName, Fields.AllAllergens, newAllergens));
  };

  hasAllergensFromIngredients = () => {
    const { formValues } = this.props;
    if (formValues[Fields.Allergens]) {
      return formValues[Fields.Allergens].find(
        (recipeAllergen) => recipeAllergen.FromIngredient
      );
    }
    return false;
  };

  render() {
    const { formValues, isReadOnly } = this.props;
    const {
      handleAllergenRowClick,
      handleNoAllergensClick,
      handleAddCustomAllergenClick,
      handleAllergensNotAvailableClick,
    } = this;

    let allergens = [];
    let recipeAllergens = [];

    if (formValues[Fields.AllAllergens]) {
      allergens = formValues[Fields.AllAllergens];
    }

    if (formValues[Fields.Allergens]) {
      recipeAllergens = formValues[Fields.Allergens];
    }

    const recipeAllergenIds = recipeAllergens.map((a) => a.Id);
    const standardAllergens = _.sortBy(
      allergens.filter((a) => !a.IsCustom),
      [(allergen) => allergen.Description]
    );

    const customAllergens = _.sortBy(
      allergens.filter((a) => a.IsCustom),
      [
        (allergen) => {
          if (allergen.IsNew) {
            return null;
          } else {
            return allergen.Description;
          }
        },
      ]
    );

    console.log(customAllergens);

    const standardAllergenList = standardAllergens.map((allergen, i) => (
      <div className="row" key={i}>
        <Field
          component={CheckboxField}
          label={allergen.Description}
          onChange={() => handleAllergenRowClick(allergen, recipeAllergens)}
          checked={recipeAllergenIds.includes(allergen.Id)}
          name={`standard-allergen-${i}`}
          disabled={isReadOnly}
        />
      </div>
    ));

    const customAllergenList = customAllergens.map((allergen, i) => {
      const allergenIndex = allergens.findIndex((a) => a.Id === allergen.Id);
      return (
        <div className="row input" key={i}>
          <Field
            component={CheckboxField}
            label={false}
            onChange={() => handleAllergenRowClick(allergen, recipeAllergens)}
            checked={recipeAllergenIds.includes(allergen.Id)}
            name={`custom-allergen-${i}`}
            disabled={isReadOnly}
          />
          {allergen.IsNew && (
            <Field
              component={InputField}
              label={false}
              hideEmptyError={true}
              name={`${Fields.AllAllergens}[${allergenIndex}].Description`}
              maxLength="30"
              disabled={isReadOnly}
            />
          )}
          {!allergen.IsNew && (
            <div>
              {formValues[Fields.AllAllergens][allergenIndex].Description}
            </div>
          )}
        </div>
      );
    });

    const isVerified = _.get(
      formValues,
      [Fields.Verified, Verified.Allergens],
      false
    );

    return (
      <div className="recipe-allergens-container">
        <div className="button-container">
          <Button
            onClick={() => this.verified(Verified.Allergens)}
            fluid
            color={isVerified ? 'green' : 'orange'}
            disabled={isReadOnly}
          >
            {isVerified ? 'Verified' : 'Click to Verify'}
          </Button>
        </div>
        <span className="break" />
        <div className="row">
          <Field
            component={CheckboxField}
            label={labels[Fields.NoAllergens]}
            name={Fields.NoAllergens}
            onClick={handleNoAllergensClick}
            disabled={isReadOnly}
          />
        </div>
        <div className="row">
          <Field
            component={CheckboxField}
            label={labels[Fields.AllergensNotAvailable]}
            name={Fields.AllergensNotAvailable}
            onClick={handleAllergensNotAvailableClick}
            disabled={isReadOnly}
          />
        </div>
        <span className="break" />
        {standardAllergenList}
        <span className="header">Custom Allergens</span>
        {customAllergenList}
        <div className="button-container">
          <Button
            onClick={handleAddCustomAllergenClick}
            fluid
            color="green"
            disabled={isReadOnly}
          >
            Add Custom Allergens
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Components/Allergens/Allergens.js